import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import ImportCsvMain from "Components/ImportCsv/ImportCsvMain";
// const ImportCsvMain = React.lazy(() =>
//   import("Components/ImportCsv/ImportCsvMain")
// );

const ImportCsv = () => {
  return (
    // <ContainerWrapper>
    <ImportCsvMain />
    // </ContainerWrapper>
  );
};

export default ImportCsv;
